import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HangmanGame from './hangmanGame//HangmanGame';
import HangmanGameWord from './hangmanGame//HangmanWord';


function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<HangmanGame />} />
        <Route path="/hangman-word" element={<HangmanGameWord />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
